<div>
  <a class="cut-text" href="{{ hrefData }}" target="_blank">
    {{ data }}
  </a>
  @if (data && data.length > 0) {
    <i class="info-icon" matSuffix matTooltip="Copy to clipboard" (click)="copyOne()"> file_copy </i>
  }
</div>
